import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgRedux, Select, Select$ } from '@angular-redux3/store';
import { toArray } from '../../../utils';
import { Observable } from 'rxjs';
import { PlaylistRemoteAppState } from '../../../store';
import { AGetAudioDevices, ASetAudioDevice } from '../../../store/actions/audio-device.actions';
import { PlayerStatus } from '../../../store/entities';


@Component({
  selector: 'mwo-sonos',
  templateUrl: './sonos.component.html',
  styleUrls: ['./sonos.component.scss']
})
export class SonosComponent implements OnInit {

  @Select$(['audio_devices'], toArray) audioDevices$: Observable<[any]>;
  @Select(['player']) player$: Observable<PlayerStatus>;
  audioDevices: [any];
  selectedAudioDeviceId: string | string[] | ConstrainDOMStringParameters | boolean;
  private loadingAudioDevice: boolean;


  constructor(public dialogRef: MatDialogRef<SonosComponent>,
              @Inject(MAT_DIALOG_DATA) public data,
              private ngRedux: NgRedux<PlaylistRemoteAppState>) {
  }

  ngOnInit(): void {
    this.ngRedux.dispatch(AGetAudioDevices());
    this.player$.subscribe((data) => {
      if (this.loadingAudioDevice) {
        setTimeout(() => {
          this.loadingAudioDevice = false;
        }, 5000);
      }
      if (data.currentAudioDevice && !this.loadingAudioDevice) {
        this.selectedAudioDeviceId = data.currentAudioDevice.id;
      }
    });
    this.audioDevices$.subscribe((data) => {
      this.audioDevices = data[0];
    });
  }

  selectAudioDevice(deviceId: string) {
    this.selectedAudioDeviceId = deviceId;
    this.loadingAudioDevice = true;
    this.ngRedux.dispatch(ASetAudioDevice(deviceId));
  }

}
